"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../lib/helpers");
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const useAutoFocus_1 = __importDefault(require("../../../hooks/Input/useAutoFocus"));
const useAddToForwardRef_1 = require("../../../hocs/useAddToForwardRef");
const useInputForm_1 = require("../../../hooks/useInputForm");
const InputButtonManager_1 = require("../InputButtonManager");
const Input = (props) => {
    var _a;
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    const inputRef = react_1.useRef(null);
    useAutoFocus_1.default(inputRef, (_a = props.autoFocus) !== null && _a !== void 0 ? _a : false);
    const ref = useAddToForwardRef_1.useAddToForwardRef(props, [inputRef]);
    const inputFormProps = useInputForm_1.useInputForm(props);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", Object.assign({}, helpers_1.without(primitiveProps, ['children']), inputFormProps, { autoComplete: props.autoComplete === false ? 'off' : props.autoComplete, ref: ref })),
        react_1.default.createElement(InputButtonManager_1.InputButtonManager, Object.assign({}, props))));
};
exports.default = withJourney_1.default('', Input);
